{
  "schemaVersion": 1,
  "checkedAt": "2026-08-09T19:42:27.730Z",
  "effectiveDate": "2026-08-10",
  "sources": [
    {
      "id": "KAC_OFFICIAL_SCHEDULE",
      "publisher": "한국공항공사",
      "url": "https://www.airport.co.kr/gimhae/cms/frCon/index.do?MENU_ID=120&CONTENTS_NO=2",
      "scope": "김포·김해·제주·대구·청주·무안·양양 국제선 계절 스케줄"
    },
    {
      "id": "ICN_OFFICIAL_D_PLUS_6",
      "publisher": "인천국제공항공사",
      "url": "https://www.airport.kr/ap_ko/869/subview.do?daySel=20260810",
      "scope": "조회일부터 7일 출발편"
    }
  ],
  "caveat": "항공사 사정으로 변경될 수 있어 예약 전 항공사 확인이 필요합니다. 공식 운항 정보를 자동으로 확인할 준비가 끝나기 전, 공식 웹에서 직접 확인한 내용입니다.",
  "routes": [
    {
      "id": "kac-78180049",
      "origin": "CJJ",
      "destination": "CTS",
      "airline": "에어로케이",
      "flightNumber": "RF3503",
      "departureLocal": "07:00",
      "weekdayMask": 93,
      "effectiveFrom": "2026.08.02",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179125",
      "origin": "CJJ",
      "destination": "CTS",
      "airline": "에어로케이",
      "flightNumber": "RF3503",
      "departureLocal": "07:05",
      "weekdayMask": 34,
      "effectiveFrom": "2026.08.01",
      "effectiveTo": "2026.08.29",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176062",
      "origin": "CJJ",
      "destination": "CTS",
      "airline": "에어로케이",
      "flightNumber": "RF352",
      "departureLocal": "08:25",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175954",
      "origin": "CJJ",
      "destination": "CTS",
      "airline": "에어로케이",
      "flightNumber": "RF356",
      "departureLocal": "13:20",
      "weekdayMask": 2,
      "effectiveFrom": "2026.07.14",
      "effectiveTo": "2026.08.18",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174502",
      "origin": "CJJ",
      "destination": "CTS",
      "airline": "에어로케이",
      "flightNumber": "RF356",
      "departureLocal": "13:20",
      "weekdayMask": 125,
      "effectiveFrom": "2026.07.22",
      "effectiveTo": "2026.08.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176066",
      "origin": "CJJ",
      "destination": "FUK",
      "airline": "에어로케이",
      "flightNumber": "RF332",
      "departureLocal": "06:35",
      "weekdayMask": 27,
      "effectiveFrom": "2026.04.21",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175950",
      "origin": "CJJ",
      "destination": "FUK",
      "airline": "에어로케이",
      "flightNumber": "RF332",
      "departureLocal": "06:35",
      "weekdayMask": 100,
      "effectiveFrom": "2026.04.22",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179789",
      "origin": "CJJ",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW225",
      "departureLocal": "17:00",
      "weekdayMask": 16,
      "effectiveFrom": "2026.07.11",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179798",
      "origin": "CJJ",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW225",
      "departureLocal": "17:05",
      "weekdayMask": 111,
      "effectiveFrom": "2026.07.12",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176054",
      "origin": "CJJ",
      "destination": "HIJ",
      "airline": "에어로케이",
      "flightNumber": "RF386",
      "departureLocal": "13:30",
      "weekdayMask": 85,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179591",
      "origin": "CJJ",
      "destination": "HKD",
      "airline": "에어로케이",
      "flightNumber": "RF3583",
      "departureLocal": "12:45",
      "weekdayMask": 72,
      "effectiveFrom": "2026.08.06",
      "effectiveTo": "2026.08.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175948",
      "origin": "CJJ",
      "destination": "KIX",
      "airline": "에어로케이",
      "flightNumber": "RF312",
      "departureLocal": "08:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175940",
      "origin": "CJJ",
      "destination": "KIX",
      "airline": "티웨이항공",
      "flightNumber": "TW327",
      "departureLocal": "10:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174492",
      "origin": "CJJ",
      "destination": "KIX",
      "airline": "에어로케이",
      "flightNumber": "RF318",
      "departureLocal": "15:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180439",
      "origin": "CJJ",
      "destination": "KKJ",
      "airline": "에어로케이",
      "flightNumber": "RF374",
      "departureLocal": "08:10",
      "weekdayMask": 23,
      "effectiveFrom": "2026.07.29",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176681",
      "origin": "CJJ",
      "destination": "KKJ",
      "airline": "에어로케이",
      "flightNumber": "RF374",
      "departureLocal": "08:20",
      "weekdayMask": 64,
      "effectiveFrom": "2026.07.05",
      "effectiveTo": "2026.10.18",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180120",
      "origin": "CJJ",
      "destination": "KKJ",
      "airline": "에어로케이",
      "flightNumber": "RF374",
      "departureLocal": "08:20",
      "weekdayMask": 32,
      "effectiveFrom": "2026.07.29",
      "effectiveTo": "2026.08.29",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180435",
      "origin": "CJJ",
      "destination": "KKJ",
      "airline": "에어로케이",
      "flightNumber": "RF374",
      "departureLocal": "08:20",
      "weekdayMask": 8,
      "effectiveFrom": "2026.07.31",
      "effectiveTo": "2026.10.22",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174494",
      "origin": "CJJ",
      "destination": "KKJ",
      "airline": "에어로케이",
      "flightNumber": "RF372",
      "departureLocal": "13:30",
      "weekdayMask": 42,
      "effectiveFrom": "2026.03.31",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179776",
      "origin": "CJJ",
      "destination": "NGO",
      "airline": "에어로케이",
      "flightNumber": "RF342",
      "departureLocal": "17:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.15",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178464",
      "origin": "CJJ",
      "destination": "NRT",
      "airline": "에어로케이",
      "flightNumber": "RF322",
      "departureLocal": "09:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.06.24",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179939",
      "origin": "CJJ",
      "destination": "NRT",
      "airline": "에어로케이",
      "flightNumber": "RF324",
      "departureLocal": "16:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.05",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178880",
      "origin": "CJJ",
      "destination": "OBO",
      "airline": "에어로케이",
      "flightNumber": "RF354",
      "departureLocal": "14:00",
      "weekdayMask": 68,
      "effectiveFrom": "2026.07.13",
      "effectiveTo": "2026.10.21",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173879",
      "origin": "CJJ",
      "destination": "OKA",
      "airline": "에어로케이",
      "flightNumber": "RF394",
      "departureLocal": "06:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78177528",
      "origin": "CJJ",
      "destination": "OKA",
      "airline": "에어로케이",
      "flightNumber": "RF396",
      "departureLocal": "18:00",
      "weekdayMask": 2,
      "effectiveFrom": "2026.07.21",
      "effectiveTo": "2026.08.18",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176739",
      "origin": "CJJ",
      "destination": "OKA",
      "airline": "에어로케이",
      "flightNumber": "RF396",
      "departureLocal": "18:00",
      "weekdayMask": 8,
      "effectiveFrom": "2026.07.23",
      "effectiveTo": "2026.08.27",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176741",
      "origin": "CJJ",
      "destination": "OKA",
      "airline": "에어로케이",
      "flightNumber": "RF396",
      "departureLocal": "18:00",
      "weekdayMask": 32,
      "effectiveFrom": "2026.07.25",
      "effectiveTo": "2026.08.29",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175859",
      "origin": "CJJ",
      "destination": "OKA",
      "airline": "에어로케이",
      "flightNumber": "RF396",
      "departureLocal": "18:05",
      "weekdayMask": 64,
      "effectiveFrom": "2026.07.26",
      "effectiveTo": "2026.08.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179618",
      "origin": "CJU",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW227",
      "departureLocal": "12:40",
      "weekdayMask": 119,
      "effectiveFrom": "2026.07.17",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179621",
      "origin": "CJU",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW227",
      "departureLocal": "12:40",
      "weekdayMask": 8,
      "effectiveFrom": "2026.07.17",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174181",
      "origin": "CJU",
      "destination": "KIX",
      "airline": "티웨이항공",
      "flightNumber": "TW331",
      "departureLocal": "16:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174848",
      "origin": "CJU",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE2125",
      "departureLocal": "12:55",
      "weekdayMask": 64,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174186",
      "origin": "CJU",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE2125",
      "departureLocal": "12:55",
      "weekdayMask": 1,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176390",
      "origin": "CJU",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE2125",
      "departureLocal": "12:55",
      "weekdayMask": 20,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174986",
      "origin": "GMP",
      "destination": "HND",
      "airline": "전일본공수",
      "flightNumber": "NH862",
      "departureLocal": "07:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.30",
      "effectiveTo": "2026.10.25",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78177288",
      "origin": "GMP",
      "destination": "HND",
      "airline": "일본항공",
      "flightNumber": "JL90",
      "departureLocal": "08:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.05.10",
      "effectiveTo": "2026.10.01",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175675",
      "origin": "GMP",
      "destination": "HND",
      "airline": "아시아나항공",
      "flightNumber": "OZ1085",
      "departureLocal": "08:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174307",
      "origin": "GMP",
      "destination": "HND",
      "airline": "대한항공",
      "flightNumber": "KE2101",
      "departureLocal": "09:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78177294",
      "origin": "GMP",
      "destination": "HND",
      "airline": "일본항공",
      "flightNumber": "JL92",
      "departureLocal": "12:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.05.10",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174988",
      "origin": "GMP",
      "destination": "HND",
      "airline": "전일본공수",
      "flightNumber": "NH864",
      "departureLocal": "12:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175001",
      "origin": "GMP",
      "destination": "HND",
      "airline": "아시아나항공",
      "flightNumber": "OZ1045",
      "departureLocal": "15:45",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174309",
      "origin": "GMP",
      "destination": "HND",
      "airline": "대한항공",
      "flightNumber": "KE2103",
      "departureLocal": "16:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176520",
      "origin": "GMP",
      "destination": "HND",
      "airline": "대한항공",
      "flightNumber": "KE2105",
      "departureLocal": "18:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176515",
      "origin": "GMP",
      "destination": "HND",
      "airline": "일본항공",
      "flightNumber": "JL94",
      "departureLocal": "19:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.09.30",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175003",
      "origin": "GMP",
      "destination": "HND",
      "airline": "아시아나항공",
      "flightNumber": "OZ1065",
      "departureLocal": "19:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180230",
      "origin": "GMP",
      "destination": "HND",
      "airline": "전일본공수",
      "flightNumber": "NH868",
      "departureLocal": "19:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.08.14",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176352",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "제주항공",
      "flightNumber": "7C1325",
      "departureLocal": "08:10",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175005",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "아시아나항공",
      "flightNumber": "OZ1145",
      "departureLocal": "08:10",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174303",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "대한항공",
      "flightNumber": "KE2117",
      "departureLocal": "09:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174990",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "피치항공",
      "flightNumber": "MM736",
      "departureLocal": "11:25",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175674",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "피치항공",
      "flightNumber": "MM738",
      "departureLocal": "13:10",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.30",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176354",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "제주항공",
      "flightNumber": "7C1327",
      "departureLocal": "13:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176516",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "대한항공",
      "flightNumber": "KE2119",
      "departureLocal": "16:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174994",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "피치항공",
      "flightNumber": "MM740",
      "departureLocal": "17:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175677",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "아시아나항공",
      "flightNumber": "OZ1165",
      "departureLocal": "17:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174996",
      "origin": "GMP",
      "destination": "KIX",
      "airline": "피치항공",
      "flightNumber": "MM744",
      "departureLocal": "18:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.30",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174998",
      "origin": "GMP",
      "destination": "NGO",
      "airline": "피치항공",
      "flightNumber": "MM764",
      "departureLocal": "11:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175000",
      "origin": "GMP",
      "destination": "NGO",
      "airline": "피치항공",
      "flightNumber": "MM768",
      "departureLocal": "17:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "icn-2026080400000007693865",
      "origin": "ICN",
      "destination": "AOJ",
      "airline": "대한항공",
      "flightNumber": "KE2193",
      "departureLocal": "09:05",
      "weekdayMask": 93,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693711",
      "origin": "ICN",
      "destination": "CTS",
      "airline": "진에어",
      "flightNumber": "LJ301",
      "departureLocal": "08:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693876",
      "origin": "ICN",
      "destination": "CTS",
      "airline": "아시아나항공",
      "flightNumber": "OZ174",
      "departureLocal": "10:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693994",
      "origin": "ICN",
      "destination": "CTS",
      "airline": "대한항공",
      "flightNumber": "KE765",
      "departureLocal": "10:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694017",
      "origin": "ICN",
      "destination": "CTS",
      "airline": "대한항공",
      "flightNumber": "KE769",
      "departureLocal": "12:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693633",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX156",
      "departureLocal": "07:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693991",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "대한항공",
      "flightNumber": "KE787",
      "departureLocal": "08:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693948",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "대한항공",
      "flightNumber": "KE791",
      "departureLocal": "11:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693728",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX158",
      "departureLocal": "11:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693733",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "진에어",
      "flightNumber": "LJ263",
      "departureLocal": "12:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694019",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "아시아나항공",
      "flightNumber": "OZ134",
      "departureLocal": "13:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693710",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "진에어",
      "flightNumber": "LJ271",
      "departureLocal": "17:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694029",
      "origin": "ICN",
      "destination": "FUK",
      "airline": "대한항공",
      "flightNumber": "KE781",
      "departureLocal": "18:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693956",
      "origin": "ICN",
      "destination": "HND",
      "airline": "대한항공",
      "flightNumber": "KE751",
      "departureLocal": "20:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693630",
      "origin": "ICN",
      "destination": "HND",
      "airline": "아시아나항공",
      "flightNumber": "OZ178",
      "departureLocal": "21:10",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696264",
      "origin": "ICN",
      "destination": "KIJ",
      "airline": "대한항공",
      "flightNumber": "KE2197",
      "departureLocal": "09:40",
      "weekdayMask": 42,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693866",
      "origin": "ICN",
      "destination": "KIJ",
      "airline": "대한항공",
      "flightNumber": "KE2197",
      "departureLocal": "17:10",
      "weekdayMask": 85,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693895",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "아시아나항공",
      "flightNumber": "OZ112",
      "departureLocal": "06:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696047",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "피치항공",
      "flightNumber": "MM712",
      "departureLocal": "07:30",
      "weekdayMask": 62,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693621",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "진에어",
      "flightNumber": "LJ231",
      "departureLocal": "07:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693947",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "대한항공",
      "flightNumber": "KE723",
      "departureLocal": "09:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693729",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "에어부산",
      "flightNumber": "BX172",
      "departureLocal": "09:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696046",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "피치항공",
      "flightNumber": "MM714",
      "departureLocal": "10:20",
      "weekdayMask": 62,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693730",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "에어부산",
      "flightNumber": "BX174",
      "departureLocal": "13:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693731",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "에어부산",
      "flightNumber": "BX176",
      "departureLocal": "14:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694020",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "대한항공",
      "flightNumber": "KE725",
      "departureLocal": "15:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693873",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "아시아나항공",
      "flightNumber": "OZ114",
      "departureLocal": "16:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693995",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "아시아나항공",
      "flightNumber": "OZ116",
      "departureLocal": "19:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693891",
      "origin": "ICN",
      "destination": "KIX",
      "airline": "대한항공",
      "flightNumber": "KE737",
      "departureLocal": "20:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693744",
      "origin": "ICN",
      "destination": "KKJ",
      "airline": "진에어",
      "flightNumber": "LJ349",
      "departureLocal": "15:45",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080600000007698708",
      "origin": "ICN",
      "destination": "KMI",
      "airline": "아시아나항공",
      "flightNumber": "OZ158",
      "departureLocal": "09:40",
      "weekdayMask": 20,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026081000000007708345",
      "origin": "ICN",
      "destination": "KMI",
      "airline": "아시아나항공",
      "flightNumber": "OZ158",
      "departureLocal": "16:20",
      "weekdayMask": 64,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696117",
      "origin": "ICN",
      "destination": "KMJ",
      "airline": "대한항공",
      "flightNumber": "KE2155",
      "departureLocal": "17:05",
      "weekdayMask": 74,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693864",
      "origin": "ICN",
      "destination": "KMQ",
      "airline": "대한항공",
      "flightNumber": "KE2189",
      "departureLocal": "07:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696262",
      "origin": "ICN",
      "destination": "KOJ",
      "airline": "대한항공",
      "flightNumber": "KE2179",
      "departureLocal": "16:20",
      "weekdayMask": 42,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693751",
      "origin": "ICN",
      "destination": "NGO",
      "airline": "진에어",
      "flightNumber": "LJ345",
      "departureLocal": "07:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693872",
      "origin": "ICN",
      "destination": "NGO",
      "airline": "아시아나항공",
      "flightNumber": "OZ122",
      "departureLocal": "09:10",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693997",
      "origin": "ICN",
      "destination": "NGO",
      "airline": "대한항공",
      "flightNumber": "KE741",
      "departureLocal": "10:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693762",
      "origin": "ICN",
      "destination": "NGO",
      "airline": "진에어",
      "flightNumber": "LJ347",
      "departureLocal": "16:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696351",
      "origin": "ICN",
      "destination": "NGO",
      "airline": "아시아나항공",
      "flightNumber": "OZ124",
      "departureLocal": "16:10",
      "weekdayMask": 126,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694028",
      "origin": "ICN",
      "destination": "NGO",
      "airline": "대한항공",
      "flightNumber": "KE743",
      "departureLocal": "19:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696076",
      "origin": "ICN",
      "destination": "NGS",
      "airline": "대한항공",
      "flightNumber": "KE2191",
      "departureLocal": "10:35",
      "weekdayMask": 42,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693763",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ201",
      "departureLocal": "07:25",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694001",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "아시아나항공",
      "flightNumber": "OZ102",
      "departureLocal": "08:25",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693990",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE703",
      "departureLocal": "10:10",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080500000007696422",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE711",
      "departureLocal": "13:00",
      "weekdayMask": 126,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693754",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ209",
      "departureLocal": "14:45",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694000",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "아시아나항공",
      "flightNumber": "OZ106",
      "departureLocal": "15:45",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694004",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE713",
      "departureLocal": "17:15",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693746",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "에티오피아항공",
      "flightNumber": "ET672",
      "departureLocal": "17:15",
      "weekdayMask": 125,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693935",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "아시아나항공",
      "flightNumber": "OZ108",
      "departureLocal": "18:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007694021",
      "origin": "ICN",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE705",
      "departureLocal": "18:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693992",
      "origin": "ICN",
      "destination": "OKA",
      "airline": "대한항공",
      "flightNumber": "KE2147",
      "departureLocal": "09:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693712",
      "origin": "ICN",
      "destination": "OKA",
      "airline": "진에어",
      "flightNumber": "LJ341",
      "departureLocal": "09:45",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693693",
      "origin": "ICN",
      "destination": "OKA",
      "airline": "아시아나항공",
      "flightNumber": "OZ172",
      "departureLocal": "14:45",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693952",
      "origin": "ICN",
      "destination": "OKJ",
      "airline": "대한항공",
      "flightNumber": "KE2185",
      "departureLocal": "10:35",
      "weekdayMask": 85,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693626",
      "origin": "ICN",
      "destination": "SDJ",
      "airline": "아시아나항공",
      "flightNumber": "OZ152",
      "departureLocal": "09:35",
      "weekdayMask": 87,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "icn-2026080400000007693617",
      "origin": "ICN",
      "destination": "SHI",
      "airline": "진에어",
      "flightNumber": "LJ357",
      "departureLocal": "08:25",
      "weekdayMask": 127,
      "effectiveFrom": "2026-08-10",
      "effectiveTo": "2026-08-16",
      "source": "ICN_OFFICIAL_D_PLUS_6"
    },
    {
      "id": "kac-78180718",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "티웨이항공",
      "flightNumber": "TW269",
      "departureLocal": "06:55",
      "weekdayMask": 34,
      "effectiveFrom": "2026.08.09",
      "effectiveTo": "2026.08.29",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176931",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "티웨이항공",
      "flightNumber": "TW269",
      "departureLocal": "07:55",
      "weekdayMask": 24,
      "effectiveFrom": "2026.06.18",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179518",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "티웨이항공",
      "flightNumber": "TW269",
      "departureLocal": "07:55",
      "weekdayMask": 64,
      "effectiveFrom": "2026.06.21",
      "effectiveTo": "2026.08.30",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78181111",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "티웨이항공",
      "flightNumber": "TW269",
      "departureLocal": "07:55",
      "weekdayMask": 1,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178825",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "티웨이항공",
      "flightNumber": "TW269",
      "departureLocal": "08:00",
      "weekdayMask": 4,
      "effectiveFrom": "2026.06.24",
      "effectiveTo": "2026.08.26",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176027",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "에어부산",
      "flightNumber": "BX182",
      "departureLocal": "09:05",
      "weekdayMask": 74,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173855",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "에어부산",
      "flightNumber": "BX182",
      "departureLocal": "09:05",
      "weekdayMask": 53,
      "effectiveFrom": "2026.06.29",
      "effectiveTo": "2026.08.29",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175988",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "제주항공",
      "flightNumber": "7C1551",
      "departureLocal": "11:00",
      "weekdayMask": 93,
      "effectiveFrom": "2026.06.01",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178246",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "진에어",
      "flightNumber": "LJ311",
      "departureLocal": "13:50",
      "weekdayMask": 8,
      "effectiveFrom": "2026.06.25",
      "effectiveTo": "2026.10.22",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78177761",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "진에어",
      "flightNumber": "LJ311",
      "departureLocal": "14:05",
      "weekdayMask": 1,
      "effectiveFrom": "2026.07.01",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78177765",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "진에어",
      "flightNumber": "LJ311",
      "departureLocal": "14:05",
      "weekdayMask": 118,
      "effectiveFrom": "2026.07.01",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176902",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "이스타항공",
      "flightNumber": "ZE951",
      "departureLocal": "14:10",
      "weekdayMask": 110,
      "effectiveFrom": "2026.06.19",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175735",
      "origin": "PUS",
      "destination": "CTS",
      "airline": "이스타항공",
      "flightNumber": "ZE951",
      "departureLocal": "15:00",
      "weekdayMask": 17,
      "effectiveFrom": "2026.07.03",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180909",
      "origin": "PUS",
      "destination": "FSZ",
      "airline": "에어부산",
      "flightNumber": "BX1645",
      "departureLocal": "09:05",
      "weekdayMask": 17,
      "effectiveFrom": "2026.08.05",
      "effectiveTo": "2026.08.26",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180587",
      "origin": "PUS",
      "destination": "FSZ",
      "airline": "에어부산",
      "flightNumber": "BX1645",
      "departureLocal": "09:05",
      "weekdayMask": 4,
      "effectiveFrom": "2026.08.05",
      "effectiveTo": "2026.08.26",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173809",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "제주항공",
      "flightNumber": "7C1451",
      "departureLocal": "07:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180096",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX148",
      "departureLocal": "07:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.17",
      "effectiveTo": "2026.09.09",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173851",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "이스타항공",
      "flightNumber": "ZE941",
      "departureLocal": "08:55",
      "weekdayMask": 125,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175850",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "진에어",
      "flightNumber": "LJ291",
      "departureLocal": "09:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175892",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "이스타항공",
      "flightNumber": "ZE941",
      "departureLocal": "09:00",
      "weekdayMask": 2,
      "effectiveFrom": "2026.03.31",
      "effectiveTo": "2026.10.20",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173843",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW231",
      "departureLocal": "09:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175125",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX142",
      "departureLocal": "10:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.05.30",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180207",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "제주항공",
      "flightNumber": "7C1453",
      "departureLocal": "13:05",
      "weekdayMask": 2,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180524",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "제주항공",
      "flightNumber": "7C1453",
      "departureLocal": "13:05",
      "weekdayMask": 125,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173859",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX146",
      "departureLocal": "14:00",
      "weekdayMask": 82,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175901",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX146",
      "departureLocal": "14:00",
      "weekdayMask": 45,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175207",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "이스타항공",
      "flightNumber": "ZE943",
      "departureLocal": "14:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176025",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "에어부산",
      "flightNumber": "BX144",
      "departureLocal": "17:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176016",
      "origin": "PUS",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW235",
      "departureLocal": "18:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176620",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "이스타항공",
      "flightNumber": "ZE913",
      "departureLocal": "06:55",
      "weekdayMask": 4,
      "effectiveFrom": "2026.04.01",
      "effectiveTo": "2026.10.21",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180833",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "제주항공",
      "flightNumber": "7C1351",
      "departureLocal": "08:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178339",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "진에어",
      "flightNumber": "LJ255",
      "departureLocal": "08:25",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.16",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78179107",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "에어부산",
      "flightNumber": "BX124",
      "departureLocal": "08:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.22",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175205",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "이스타항공",
      "flightNumber": "ZE913",
      "departureLocal": "09:05",
      "weekdayMask": 72,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.22",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175890",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "티웨이항공",
      "flightNumber": "TW319",
      "departureLocal": "09:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176622",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "이스타항공",
      "flightNumber": "ZE913",
      "departureLocal": "10:00",
      "weekdayMask": 32,
      "effectiveFrom": "2026.04.04",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178173",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "이스타항공",
      "flightNumber": "ZE913",
      "departureLocal": "10:00",
      "weekdayMask": 17,
      "effectiveFrom": "2026.06.01",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178175",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "이스타항공",
      "flightNumber": "ZE913",
      "departureLocal": "10:05",
      "weekdayMask": 2,
      "effectiveFrom": "2026.07.07",
      "effectiveTo": "2026.08.25",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180369",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "에어부산",
      "flightNumber": "BX126",
      "departureLocal": "11:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.17",
      "effectiveTo": "2026.09.09",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175877",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "티웨이항공",
      "flightNumber": "TW321",
      "departureLocal": "13:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173847",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "이스타항공",
      "flightNumber": "ZE915",
      "departureLocal": "13:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175993",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "진에어",
      "flightNumber": "LJ251",
      "departureLocal": "13:35",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78173821",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "진에어",
      "flightNumber": "LJ253",
      "departureLocal": "15:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180377",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "에어부산",
      "flightNumber": "BX122",
      "departureLocal": "16:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.08.01",
      "effectiveTo": "2026.09.09",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180343",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "제주항공",
      "flightNumber": "7C1353",
      "departureLocal": "16:55",
      "weekdayMask": 125,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.16",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180349",
      "origin": "PUS",
      "destination": "KIX",
      "airline": "제주항공",
      "flightNumber": "7C1353",
      "departureLocal": "17:00",
      "weekdayMask": 2,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.16",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174409",
      "origin": "PUS",
      "destination": "KMJ",
      "airline": "이스타항공",
      "flightNumber": "ZE967",
      "departureLocal": "12:30",
      "weekdayMask": 17,
      "effectiveFrom": "2026.05.01",
      "effectiveTo": "2026.10.23",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176618",
      "origin": "PUS",
      "destination": "KMJ",
      "airline": "이스타항공",
      "flightNumber": "ZE967",
      "departureLocal": "12:30",
      "weekdayMask": 110,
      "effectiveFrom": "2026.05.02",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78178720",
      "origin": "PUS",
      "destination": "MYJ",
      "airline": "에어부산",
      "flightNumber": "BX134",
      "departureLocal": "16:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.07.24",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175187",
      "origin": "PUS",
      "destination": "NGO",
      "airline": "진에어",
      "flightNumber": "LJ375",
      "departureLocal": "08:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174837",
      "origin": "PUS",
      "destination": "NGO",
      "airline": "대한항공",
      "flightNumber": "KE2133",
      "departureLocal": "17:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175848",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "제주항공",
      "flightNumber": "7C1151",
      "departureLocal": "07:30",
      "weekdayMask": 127,
      "effectiveFrom": "2026.06.01",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78181103",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "에어부산",
      "flightNumber": "BX112",
      "departureLocal": "07:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.08.08",
      "effectiveTo": "2026.08.27",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180879",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ221",
      "departureLocal": "07:55",
      "weekdayMask": 127,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174835",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE2129",
      "departureLocal": "09:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175130",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "제주항공",
      "flightNumber": "7C1153",
      "departureLocal": "11:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.06.01",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180891",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ223",
      "departureLocal": "14:00",
      "weekdayMask": 65,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180897",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ223",
      "departureLocal": "14:00",
      "weekdayMask": 4,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180261",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ223",
      "departureLocal": "14:00",
      "weekdayMask": 32,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78180885",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "진에어",
      "flightNumber": "LJ223",
      "departureLocal": "14:00",
      "weekdayMask": 26,
      "effectiveFrom": "2026.08.03",
      "effectiveTo": "2026.08.31",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78174168",
      "origin": "PUS",
      "destination": "NRT",
      "airline": "대한항공",
      "flightNumber": "KE2131",
      "departureLocal": "16:00",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175896",
      "origin": "PUS",
      "destination": "OKA",
      "airline": "이스타항공",
      "flightNumber": "ZE963",
      "departureLocal": "08:00",
      "weekdayMask": 106,
      "effectiveFrom": "2026.03.31",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175185",
      "origin": "PUS",
      "destination": "OKA",
      "airline": "진에어",
      "flightNumber": "LJ371",
      "departureLocal": "08:05",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175193",
      "origin": "PUS",
      "destination": "SHI",
      "airline": "진에어",
      "flightNumber": "LJ363",
      "departureLocal": "14:45",
      "weekdayMask": 72,
      "effectiveFrom": "2026.04.02",
      "effectiveTo": "2026.10.22",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78176608",
      "origin": "PUS",
      "destination": "TAK",
      "airline": "에어부산",
      "flightNumber": "BX1325",
      "departureLocal": "17:20",
      "weekdayMask": 82,
      "effectiveFrom": "2026.03.31",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175225",
      "origin": "TAE",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW213",
      "departureLocal": "08:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.09.01",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175907",
      "origin": "TAE",
      "destination": "FUK",
      "airline": "티웨이항공",
      "flightNumber": "TW215",
      "departureLocal": "17:20",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175911",
      "origin": "TAE",
      "destination": "KIX",
      "airline": "티웨이항공",
      "flightNumber": "TW313",
      "departureLocal": "16:50",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    },
    {
      "id": "kac-78175229",
      "origin": "TAE",
      "destination": "NRT",
      "airline": "티웨이항공",
      "flightNumber": "TW251",
      "departureLocal": "10:40",
      "weekdayMask": 127,
      "effectiveFrom": "2026.03.29",
      "effectiveTo": "2026.10.24",
      "source": "KAC_OFFICIAL_SCHEDULE"
    }
  ]
}
